import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.CurrentRaportView.heading',
    defaultMessage: 'Raport '
  },
  return: {
    id: 'views.CurrentRaportView.return',
    defaultMessage: 'POWRÓT'
  },
  journalistContact: {
    id: 'views.CurrentRaportView.journalistContact',
    defaultMessage: 'KONTAKT DLA DZIENNIKARZY'
  },
  filesToDownload: {
    id: 'views.CurrentRaportView.filesToDownload',
    defaultMessage: 'ZAŁĄCZNIKI'
  },
  zipFilesToDownload: {
    id: 'views.CurrentRaportView.zipFilesToDownload',
    defaultMessage: 'Pobierz pozostałe załączniki:'
  },
  graphicsToDownload: {
    id: 'views.CurrentRaportView.graphicsToDownload',
    defaultMessage: 'Pobierz materiały graficzne:'
  }
});



// WEBPACK FOOTER //
// ./src/views/CurrentReport/CurrentReportView.intl.js